import { call, put, takeLatest } from "redux-saga/effects";
import { brandActions } from "./brandSlice";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";
import brandApi from "api/brand";
import { BrandPayload, BrandSubmitForm, UpdateBrandStatus } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

function* getBrandList(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.getBrandsList,
      action.payload
    );
    const data: ApiResponse = response?.data;
    if (data.success) {
      yield put(brandActions.getBrandSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(brandActions.getBrandFailed(errorData));
  }
}

function* getLocationsAndStoresByBrand(action: PayloadAction<string>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.getLocationsAndStoresByBrand,
      action.payload
    );
    const data: ApiResponse = response?.data;

    if (data.success) {
      yield put(brandActions.getLocationsAndStoresByBrandSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(brandActions.getLocationsAndStoresByBrandFailed(errorData));
  }
}

function* getKotConfigs(action: PayloadAction<string>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.getKotConfigs,
      action.payload
    );

    const data: ApiResponse = response?.data;

    if (data?.success) {
      yield put(brandActions.getKotConfigsSuccess(data));
    } else {
      yield put(
        brandActions.getKotConfigsFailed({
          message: data?.message || "Failed to fetch Kot configs ❌",
        })
      );
    }
  } catch (error: any) {
    const errorData = error.response?.data || {
      message: "Something went wrong ❌",
    };
    yield put(brandActions.getKotConfigsFailed(errorData));
  }
}
function* getBrandDatabyId(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.getBrandbyId,
      action.payload
    );
    const data: ApiResponse = response?.data;
    if (data.success) {
      yield put(brandActions.getBrandbyIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(brandActions.getBrandbyIdFailed(errorData));
  }
}

function* getCustomersList(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.getCustomersList,
      action.payload
    );
    const data: ApiResponse = response?.data;
    if (data.success) {
      yield put(brandActions.getCustomersListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(brandActions.getCustomersListFailed(errorData));
  }
}

function* addBrand(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(brandApi.addBrand, action.payload);
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandActions.addBrandSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandActions.addBrandFailed(errorData));
  }
}
function* addOrUpdateMultiStoreKotConfig(
  action: PayloadAction<{
    brandId: string;
    locationId: string;
    associatedStoreIds: string[];
  }>
) {
  try {
    const response: ApiResponse = yield call(
      brandApi.addOrUpdateMultiStoreKotConfig,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandActions.addOrUpdateMultiStoreKotConfigSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandActions.addOrUpdateMultiStoreKotConfigFailed(errorData));
  }
}
function* getAllMainBrand() {
  try {
    const response: ApiResponse = yield call(brandApi.getAllMainBrand);
    const data: any = response.data;

    if (data.success) {
      yield put(brandActions.getMainBrandSuccess(data.data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(brandActions.getMainBrandsFailed(errorData));
  }
}

function* updateBrand(action: PayloadAction<BrandSubmitForm>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.updateBrand,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandActions.updateBrandSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandActions.updateBrandFailed(errorData));
  }
}

function* deleteBrand(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.deleteBrand,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandActions.deleteBrandSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandActions.deleteBrandFailed(errorData));
  }
}

function* getImageUrl(action: PayloadAction<ImageUrlData>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.getImageUrl,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandActions.getImageUrlSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandActions.getImageUrlFailed(errorData));
  }
}

function* changeBrandStatus(action: PayloadAction<UpdateBrandStatus>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.changeBrandStatus,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(brandActions.changeBrandStatusSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(brandActions.changeBrandStatusFailed(errorData));
  }
}
function* getBrandLocationSaga(action: PayloadAction<string>) {
  try {
    const response: ApiResponse = yield call(
      brandApi.getBrandLocation,
      action.payload
    );
    const data: ApiResponse = response?.data;

    if (data.success) {
      yield put(brandActions.getBrandLocationSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(brandActions.getBrandLocationFailed(errorData));
  }
}

export default function* brandSaga() {
  yield takeLatest(brandActions.getBrands.type, getBrandList);
  yield takeLatest(
    brandActions.getLocationsAndStoresByBrand.type,
    getLocationsAndStoresByBrand
  );
  yield takeLatest(brandActions.getBrandbyId.type, getBrandDatabyId);
  yield takeLatest(brandActions.getCustomersList.type, getCustomersList);
  yield takeLatest(brandActions.addBrand.type, addBrand);
  yield takeLatest(brandActions.updateBrand.type, updateBrand);
  yield takeLatest(brandActions.deleteBrand.type, deleteBrand);
  yield takeLatest(brandActions.getImageUrl.type, getImageUrl);
  yield takeLatest(brandActions.changeBrandStatus.type, changeBrandStatus);
  yield takeLatest(brandActions.getMainBrands.type, getAllMainBrand);
  yield takeLatest(brandActions.getBrandLocation.type, getBrandLocationSaga);
  yield takeLatest(
    brandActions.addOrUpdateMultiStoreKotConfig.type,
    addOrUpdateMultiStoreKotConfig
  );
  yield takeLatest(brandActions.getKotConfigs.type, getKotConfigs);
}
